import React, { useCallback, useMemo } from 'react'
import * as icons from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'
import { AccountAnalysisStatus } from '@mutual-services/account-types'

type Icon = keyof typeof icons

type BadgeType = 'error' | 'success' | 'info' | 'warning'

export type StatusIconContainerProps = {
  type: BadgeType,
  status: AccountAnalysisStatus
}

export const StatusIconContainer: React.FC<StatusIconContainerProps> = (props) => {
  const { status, type } = props

  const getStatusIcon = useCallback((): Icon => {
    if (status === AccountAnalysisStatus.ANALYST_QUEUE ||
      status === AccountAnalysisStatus.WAITING_FOR_ANALYSIS ||
      status === AccountAnalysisStatus.UNDER_ANALYSIS) {
      return 'ListIcon'
    }
    if (status === AccountAnalysisStatus.DENIED ||
      status === AccountAnalysisStatus.DENIED_POST_ANALYSIS) {
      return 'CloseIcon'
    }

    return 'CheckIcon'
  }, [status])

  const Icon = useMemo(() => icons[getStatusIcon()], [getStatusIcon])

  return <Icon htmlColor={mutualTheme.palette.badgeBackgroundColor[type].light} />
}
